import soundcloudConfig from "../../config/soundcloudConfig";

function canUseStorage() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function readCachedClientId() {
  if (!canUseStorage()) return null;

  try {
    const raw = window.localStorage.getItem(soundcloudConfig.CLIENT_ID_CACHE_KEY);
    if (!raw) return null;

    const payload = JSON.parse(raw);
    if (!payload || typeof payload !== "object") return null;

    const { clientId, createdAt } = payload;
    if (typeof clientId !== "string" || typeof createdAt !== "number") return null;

    const isValid = soundcloudConfig.CLIENT_ID_REGEX.test(clientId);
    const notExpired = Date.now() - createdAt < soundcloudConfig.CLIENT_ID_CACHE_TTL_MS;

    if (!isValid || !notExpired) return null;

    return { clientId, createdAt };
  } catch {
    return null;
  }
}

export function saveCachedClientId(clientId) {
  if (!canUseStorage()) return;

  if (!soundcloudConfig.CLIENT_ID_REGEX.test(clientId)) return;

  const payload = {
    clientId,
    createdAt: Date.now(),
  };

  try {
    window.localStorage.setItem(soundcloudConfig.CLIENT_ID_CACHE_KEY, JSON.stringify(payload));
  } catch {
    // Ignore storage write errors.
  }
}

export function clearCachedClientId() {
  if (!canUseStorage()) return;

  try {
    window.localStorage.removeItem(soundcloudConfig.CLIENT_ID_CACHE_KEY);
  } catch {
    // Ignore storage remove errors.
  }
}
